import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import SubmitButton from '../../../../components/SubmitButton';
import messages from '../messages';
import { navigateToUrlWithSelectedPropertyId } from '../../../../utils/navigation-helpers';
export const CreateWorkOrderButtonsRow = ({
  history,
  formatMessage,
  disabled,
  handleSubmit,
  onSubmit,
  isSubmitting,
}: Object) => (
  <Row>
    <Col xs={12}>
      <div className="form-footer padtop20">
        <div className="button-group">
          <Button
            bsStyle="default"
            onClick={() =>
              navigateToUrlWithSelectedPropertyId('/manage-work-orders')
            }
          >
            {formatMessage(messages.cancel)}
          </Button>
          <SubmitButton
            bsStyle="primary"
            clickHandler={handleSubmit(onSubmit(false))}
            disabled={disabled}
            isSubmitting={isSubmitting}
          >
            {formatMessage(messages.create)}
          </SubmitButton>
          <SubmitButton
            bsStyle="primary"
            clickHandler={handleSubmit(onSubmit(true))}
            disabled={disabled}
            isSubmitting={isSubmitting}
          >
            {formatMessage(messages.createAndPrint)}
          </SubmitButton>
        </div>
      </div>
    </Col>
  </Row>
);
